// extracted by mini-css-extract-plugin
export default {"root":"mohxP8QVQJTNBeO54C5d"};